Object.defineProperty(exports, '__esModule', { value: true });

var GlobalStore = require('./GlobalStore.js');

var getCoreComponentsStore = function () {
    if (!window.coreComponentsStore) {
        window.coreComponentsStore = new GlobalStore.GlobalStore();
        return window.coreComponentsStore;
    }
    return window.coreComponentsStore;
};
var getModalStore = function () { return getCoreComponentsStore().getModalStore(); };

exports.getModalStore = getModalStore;
